function addMark(mark) {
	if (typeof window.performance === 'undefined') {
		return;
	}

	return window.performance.mark(mark);
}

function getMarks() {
	if (typeof window.performance === 'undefined') {
		return;
	}

	return window.performance.getEntriesByType('mark');
}

module.exports = {
	addMark,
	getMarks
};
